import React from 'react';
import {
    Card,
    CardHeader,
    Divider,
    Table,
    TableBody,
    makeStyles,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ILeadInfo, TValue } from './types';
import { TextRow } from './TextRow';

const useStyles = makeStyles(() => ({
    paper: {
        overflow: 'scroll',
    },
    margin: {
        marginBottom: '1em',
    },
    icon: {
        marginLeft: 10,
    },
}));

export const AppointmentVisitInfo = ({
    lead,
    loading,
    ...props
}: ILeadInfo) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const VALUES: TValue[] = [
        {
            header: t('Charts.appointment'),
            text: lead?.appointments?.length > 0 ? lead.appointments.length : 0,
        },
        {
            header: t('Charts.visit'),
            text: lead?.visits?.length > 0 ? lead.visits.length : 0,
        },
    ];

    return (
        <Card className={classes.paper} {...props}>
            <CardHeader title={t('Leads.InfoFollow')} />
            <Divider />
            <Table className={classes.margin}>
                <TableBody>
                    {VALUES.map((item, key) => (
                        <TextRow key={key} item={item} loading={loading} />
                    ))}
                </TableBody>
            </Table>
        </Card>
    );
};
